<div id="main-wrapper">
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- Main wrapper - style you can find in pages.scss -->
  <!-- ============================================================== -->
  <nav class="navbar navbar-dark fixed-top navbar-expand-md navbar-no-bg">
    <div class="container">
      <a class="navbar-brand" href="index.html">
        EL PREFERIDO
      </a>
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarNavDropdown"
        aria-controls="navbarNavDropdown"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div id="navbarNavDropdown" class="navbar-collapse collapse">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a [routerLink]="['/dashboard']" class="nav-link scroll-link"
              >Inicio</a
            >
          </li>
          <li class="nav-item">
            <a
              *hasPermission="['administrador']"
              [routerLink]="['/dashboard/usuarios']"
              class="nav-link scroll-link"
              >Usuarios</a
            >
          </li>

          <li
            *hasPermission="['administrador', 'almacen', 'contador']"
            class="nav-item dropdown"
          >
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Almacen
            </a>

            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a
                *hasPermission="['administrador', 'almacen']"
                class="nav-link"
                [routerLink]="['/dashboard/categoria']"
                >Categorias</a
              >
              <a
                *hasPermission="['administrador', 'almacen']"
                class="nav-link"
                [routerLink]="['/dashboard/productos']"
                >Productos</a
              >
              <a
                *hasPermission="['administrador', 'almacen', 'contador']"
                class="nav-link"
                [routerLink]="['/dashboard/almacen']"
                >Ingresos</a
              >
              <a
                *hasPermission="['administrador', 'almacen']"
                class="nav-link"
                [routerLink]="['/dashboard/unidades']"
                >unidades</a
              >
            </div>
          </li>
          <li class="nav-item dropdown">

            <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Pedidos
          </a>

          <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
          
            <a
            *hasPermission="['administrador', 'vendedor', 'almacen']"
            class="nav-link"
            [routerLink]="['/dashboard/order-list']"
            >Pedidos</a>
            <a
            *hasPermission="['administrador', 'vendedor', 'almacen']"
            class="nav-link"
            [routerLink]="['/dashboard/proforma-list']"
            >Proformas</a>

            <a
            *hasPermission="['administrador', 'vendedor']"
            class="nav-link"
            [routerLink]="['/dashboard/clientes']"
            >Clientes</a
          >
        
          <a
          *hasPermission="['administrador', 'vendedor']"
          class="nav-link"
          [routerLink]="['/dashboard/visitas']"
          >Visitas</a>

          </div>


           
          </li>

         
          <li class="nav-item dropdown">
            <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdownMenuLink"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Pagos
          </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">

           
            <a
              *hasPermission="['administrador', 'almacen','contador']"
              class="nav-link"
              [routerLink]="['/dashboard/ventas']"
              >Cobranzas</a
            >
            <a
            *hasPermission="['administrador', 'almacen','contador']"
            class="nav-link"
            [routerLink]="['/dashboard/pagos']"
            >Pago a proveedores</a
          >
            </div>
          </li>

          <li class="nav-item">
            <a
              *hasPermission="['administrador', 'contador']"
              class="nav-link"
              [routerLink]="['/dashboard/expense']"
              >Gastos</a
            >
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Reportes
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a class="dropdown-item" [routerLink]="['/dashboard/existencia']"
                >Existencia</a
              >
              <a class="dropdown-item" [routerLink]="['/dashboard/reporte-monetizado']"
              >Monetizado</a
            >
              <a
                class="dropdown-item"
                [routerLink]="['/dashboard/reporte-existencia']"
                *hasPermission="['administrador', 'Almacen','contador']"
                >Ingresos</a
              >
              <a
                class="dropdown-item"
                [routerLink]="['/dashboard/reporte-vendedor']"
                *hasPermission="['vendedor']"
                >Reporte de Ventas</a
              >
              <a
                class="dropdown-item"
                [routerLink]="['/dashboard/reporte-precios']"
                *hasPermission="['administrador', 'Contador']"
                >Precios</a
              >
              <a
                class="dropdown-item"
                [routerLink]="['/dashboard/reporte-venta']"
                *hasPermission="['administrador', 'Contador']"
                >Ventas</a
              >
              <a
                class="dropdown-item"
                [routerLink]="['/dashboard/reporte-gasto']"
                *hasPermission="['administrador', 'Contador']"
                >Gastos</a
              >
              <a
                class="dropdown-item"
                *hasPermission="['administrador', 'Contador']"
                [routerLink]="['/dashboard/productos-pedidos']"
                >Preventa</a
              >
              <a
                class="dropdown-item"
                *hasPermission="['administrador', 'Contador']"
                [routerLink]="['/dashboard/reporte-deudas']"
                >Deudas</a
                
              >
              <a
              class="dropdown-item"
              *hasPermission="['administrador', 'Contador']"
              [routerLink]="['/dashboard/reporte-seguimiento']"
              >Seguimiento Producto</a>

              <a
              class="dropdown-item"
              *hasPermission="['administrador', 'Contador']"
              [routerLink]="['/dashboard/reporte-cobranzas']"
              >Reporte de Cobranzas</a>

            </div>
          </li>
        </ul>
        <ul class="navbar-nav">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="http://example.com"
              id="navbarDropdownMenuLink"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {{ username }}
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
              <a
                class="dropdown-item"
                (click)="eliminarCache()"
                [routerLink]="['/']"
              >
                <i class="ti-layout-sidebar-left"></i> Cerrar Sesión
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <!-- Top content -->
  <!-- Page wrapper  -->
  <!-- ============================================================== -->
  <div style="padding-top: 90px;" class="page-wrapper">
    <!-- ============================================================== -->

    <!-- Container fluid  -->
    <!-- ============================================================== -->
    <div class="container">
      <app-breadcrumb></app-breadcrumb>
      <!-- ============================================================== -->
      <!-- Start Page Content -->
      <!-- ============================================================== -->
      <router-outlet></router-outlet>
      <!-- ============================================================== -->
      <!-- End Start Page Content -->
      <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
  </div>
  <!-- ============================================================== -->
  <!-- End Page wrapper  -->
  <!-- ============================================================== -->
  <!-- ============================================================== -->
  <!-- footer -->
  <!-- ============================================================== -->
  <footer class="p-5">
    <div class="container text-center">
      <a class="logo-font" routerLink="/">Distribuidor - EL PREFERIDO </a>
      <span class="attribution">
        &copy; 2023. Todos los derechos reservados
      </span>
    </div>
  </footer>

  <!-- ============================================================== -->
  <!-- End footer -->
  <!-- ============================================================== -->
</div>
